<template>
    <div>
        <div class="row">
            <div class="col-md-6">
                <h4>Paying by Phone</h4>
                <p>Please call us on <strong>01923 777 778</strong> after submitting your order and quote the order reference on your confirmation email.</p>
                <p>Once payment has been made we will ready your order for shipment.</p>
            </div>

            <div class="col-md-6" v-if="!phoneOnly">
                <h4>Paying by Cheque</h4>
                <p>
                    Please make Cheques payable to <strong>Orbital Fasteners</strong> and send to Olds Approach, Tolpits Lane, Watford WD18 9XT
                </p>
                <p class="text-warning"><strong>IMPORTANT!</strong> Please ensure you include the order reference from your confirmation email on the envelope.</p>
            </div>
        </div>
        <div class="row">
            <div class="col-xs-12 col-md-12 text-right">
                <button class="btn btn-green" @click="submit" :disabled="processing">
                    <template v-if="!processing">
                        <i class="fa fa-lock"></i> Submit Order
                    </template>
                    <template v-else>
                        <i class="fa fa-refresh fa-spin"></i> Processing
                    </template>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import Checkout from '../../../Services/Checkout.js';
    import Order from '../../../Services/Order.js';

    export default {
        props: {
            gatewayId: {
                type: String,
                required: true
            },
            phoneOnly: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                processing: false,
                checkout: Checkout,
                order: Order,
            }
        },
        methods: {
            submit() {
                this.processing = true;
                this.checkout.setType('Offline Payment')
                .setGatewayId(this.gatewayId).process(
                    undefined,
                    undefined,
                    this.order.reference,
                    this.order.notes
                ).then(response => {
                    this.$emit('complete');
                }).catch(error => {
                    this.$emit('failed');
                });
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/Components/Checkout/Payments/OfflineGateway.vue